module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Map/Compass-f8ad8f8b6538e3740178831247e41a24.svg";